import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NiveauLivreurDTO, NiveauLivreurService } from 'src/app/core/services/niveau-livreur.service';

@Component({
  selector: 'app-niveaux-livreur',
  templateUrl: './niveaux-livreur.component.html',
  styleUrls: ['./niveaux-livreur.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NiveauxLivreurComponent implements OnInit {

  niveaux: NiveauLivreurDTO[] = [];
  chargement = true;
  enregistrement = false;

  form!: FormGroup;
  editId: number | null = null;
  afficherFormulaire = false;

  constructor(
    private service: NiveauLivreurService,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.charger();
  }

  private initForm(data?: Partial<NiveauLivreurDTO>): void {
    this.form = this.fb.group({
      nom:               [data?.nom || '',           Validators.required],
      seuilMinCourses:   [data?.seuilMinCourses ?? 0, [Validators.required, Validators.min(0)]],
      couleur:           [data?.couleur || '#CD7F32'],
      emoji:             [data?.emoji || '🥉'],
      primeFixeMensuelle:[data?.primeFixeMensuelle ?? 0, Validators.min(0)],
      primePourcentageCa:[data?.primePourcentageCa ?? 0, [Validators.min(0), Validators.max(100)]],
      ordre:             [data?.ordre ?? 1,           [Validators.required, Validators.min(1)]]
    });
  }

  charger(): void {
    this.chargement = true;
    this.service.lister().subscribe({
      next: n => { this.niveaux = n; this.chargement = false; this.cdr.markForCheck(); },
      error: () => { this.chargement = false; this.cdr.markForCheck(); }
    });
  }

  ouvrir(niveau?: NiveauLivreurDTO): void {
    this.editId = niveau?.id ?? null;
    this.initForm(niveau);
    this.afficherFormulaire = true;
    this.cdr.markForCheck();
  }

  fermer(): void {
    this.afficherFormulaire = false;
    this.editId = null;
    this.cdr.markForCheck();
  }

  enregistrer(): void {
    if (this.form.invalid) { this.form.markAllAsTouched(); return; }
    this.enregistrement = true;
    const dto = this.form.getRawValue() as NiveauLivreurDTO;
    const op = this.editId
      ? this.service.modifier(this.editId, dto)
      : this.service.creer(dto);
    op.subscribe({
      next: () => { this.enregistrement = false; this.fermer(); this.charger(); },
      error: () => { this.enregistrement = false; this.cdr.markForCheck(); }
    });
  }

  supprimer(id: number): void {
    if (!confirm('Supprimer ce niveau ?')) return;
    this.service.supprimer(id).subscribe(() => this.charger());
  }

  trackById(_: number, n: NiveauLivreurDTO): number { return n.id!; }
}
